import { useQuery } from '@tanstack/react-query';
import { fetchWebhooksList } from '@api/notificationChannel';

function useFetchWebhooksList({ context = 'video' }) {
  const queryKey = ['webhooksListData', { context }];

  const {
    data = null,
    error,
    isLoading,
  } = useQuery(
    queryKey,
    async () => {
      const response = await fetchWebhooksList({
        context,
      });
      return response.data;
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5m
    },
  );
  return { data, error, isLoading };
}

export default useFetchWebhooksList;
